import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    width: "100%",
  },
  row: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "16px",
    minHeight: "42px",
  },
  yardRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "16px",
    height: "42px",
    minHeight: "42px",
    maxHeight: "42px",
    opacity: 1,
    transform: "rotate(0deg)",
  },
  search: {
    width: "280px",
    "& .MuiOutlinedInput-root": {
      height: "42px",
      borderRadius: "4px",
      background: theme.palette.background.paper,
      direction: "ltr",
      padding: "0 8px",
      "& fieldset": {
        borderColor: theme.palette.divider,
      },
    },
    "& .MuiOutlinedInput-input": {
      padding: "5px 8px",
      fontSize: "13px",
      color: theme.palette.text.secondary,
      textAlign: "right",
      direction: "rtl",
      fontFamily: "Noto Sans Hebrew",
    },
    "& .MuiOutlinedInput-input::placeholder": {
      color: theme.palette.text.secondary,
      opacity: 0.7,
      textAlign: "right",
    },
  },
  searchButton: {
    boxSizing: "border-box",
    width: 42,
    height: 42,
    minWidth: 42,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 10,
    paddingTop: 0,
    paddingBottom: 0,
    paddingRight: 16,
    paddingLeft: 16,
    borderRadius: "4px !important",
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: theme.palette.divider,
    opacity: 1,
    transform: "rotate(0deg)",
    position: "relative",
    backgroundColor: theme.palette.common.white,
    "&:hover": {
      backgroundColor: theme.palette.common.white,
    },
    "& .MuiSvgIcon-root": {
      position: "absolute",
      top: "50%",
      left: "50%",
      margin: 0,
      transform: "translate(-50%, -50%) scaleX(-1)",
    },
  },
  searchIcon: {
    fontSize: "26px !important",
    color: theme.palette.text.secondary,
    marginRight: "6px",
    transform: "scaleX(-1)",
  },
}));
